import { render } from "./WhyChooseUs.vue?vue&type=template&id=294b7061"
import script from "./WhyChooseUs.vue?vue&type=script&lang=js"
export * from "./WhyChooseUs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__